var _IconContainer, _Selector, _TenantTitle, _X, _Check, _CirclePlus;
import * as React from 'react';
import { IconButton, Search, Button } from '@ovpn-ui/core';
import { Selector, Cloud, Check, X, CirclePlus } from '@ovpn-ui/icons';
import { Container, CurrentTenant, NoWrap, TenantMenu, TenantLabel, TenantHeader, SearchContainer, TenantTitle, TenantList, StyledOption, LabelContainer, IconContainer, TenantFooter, StyledTenantSwitcher } from './TenantSwitcher.styles';
import { useFloatingUiMiddleware } from './hooks';
import { sidebarWidth } from '../Sidebar.constants';
import { useDimensions, useSidebar } from '../../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function TenantSwitcher({
  content,
  links,
  addTenant,
  description,
  showFooter = true
}) {
  const [isTenantSwitcherOpen, setIsTenantSwitcherOpen] = React.useState(false);
  const isSidebarOpen = useSidebar();
  const {
    isMobile,
    isTablet
  } = useDimensions();
  const [collapsed, setCollapsed] = React.useState(() => !isSidebarOpen);
  React.useEffect(() => {
    const shouldBeCollapsed = !isSidebarOpen && !(isMobile || isTablet);
    setCollapsed(shouldBeCollapsed);
  }, [isMobile, isTablet, isSidebarOpen]);

  // Description state
  const [currentDescription, setCurrentDescription] = React.useState(typeof description === 'string' ? description : null);

  // Link state
  const [activeLink, setActiveLink] = React.useState(null);
  const handleLinkClick = link => {
    setIsTenantSwitcherOpen(false);
    setActiveLink(link);

    //  Link click handlers
    if (link.onNavigate) {
      link.onNavigate();
    } else if (link.href) {
      window.location.href = link.href;
    }
    if (typeof link.label === 'string') {
      setCurrentDescription(link.label);
    } else {
      setCurrentDescription('');
    }
    clearSearchQuery();
  };
  React.useEffect(() => {
    const initialActiveLink = links.find(link => link.activeOn);
    setActiveLink(initialActiveLink || null);
  }, [links]);

  // Close button
  const handleClose = () => {
    setIsTenantSwitcherOpen(false);
    clearSearchQuery();
  };

  // UseEffect to check and set active link based on description
  React.useEffect(() => {
    const linkMatchingDescription = links.find(link => link.label === currentDescription);
    if (linkMatchingDescription) {
      setActiveLink(linkMatchingDescription);
    }
  }, [currentDescription, links]);

  // Search
  // Search query state
  const [searchQuery, setSearchQuery] = React.useState('');

  // Filter the links based on the search query
  const filteredLinks = links.filter(link => {
    if (typeof link.label === 'string') {
      return link.label.toLowerCase().includes(searchQuery.toLowerCase());
    }
    // Handle the case where link.label is a JSX.Element, you can choose to ignore or handle it differently.
    return false;
  });

  // Update the search query state when the user types
  const handleSearch = query => {
    setSearchQuery(query);
  };

  // Function to clear the search query
  const clearSearchQuery = () => {
    setSearchQuery('');
  };
  const middlewares = useFloatingUiMiddleware();
  return /*#__PURE__*/_jsx(StyledTenantSwitcher, {
    open: isTenantSwitcherOpen,
    onChange: setIsTenantSwitcherOpen,
    strategy: "fixed",
    placement: "right-start",
    middlewares: middlewares,
    style: {
      padding: 0
    },
    overlayStyle: {
      width: isMobile ? '100%' : `${sidebarWidth}px`
    },
    trigger: /*#__PURE__*/_jsxs(Container, {
      "aria-label": "Select Tenant",
      interactive: true,
      collapsed: collapsed,
      mobile: isMobile,
      tablet: isTablet,
      children: [_IconContainer || (_IconContainer = /*#__PURE__*/_jsx(IconContainer, {
        children: /*#__PURE__*/_jsx(Cloud, {})
      })), !collapsed && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(CurrentTenant, {
          children: [/*#__PURE__*/_jsx(NoWrap, {
            variant: "textSm",
            weight: "medium",
            mobile: isMobile || isTablet,
            children: currentDescription
          }), content && /*#__PURE__*/_jsx(NoWrap, {
            variant: "textSm",
            weight: "regular",
            mobile: isMobile || isTablet,
            children: content
          })]
        }), _Selector || (_Selector = /*#__PURE__*/_jsx(Selector, {}))]
      })]
    }),
    children: /*#__PURE__*/_jsxs(TenantMenu, {
      mobile: isMobile,
      children: [/*#__PURE__*/_jsxs(TenantHeader, {
        children: [_TenantTitle || (_TenantTitle = /*#__PURE__*/_jsx(TenantTitle, {
          children: "Switch Cloud ID"
        })), /*#__PURE__*/_jsx(IconButton, {
          "aria-label": "Close",
          variant: "tertiary",
          onClick: handleClose,
          children: _X || (_X = /*#__PURE__*/_jsx(X, {}))
        })]
      }), /*#__PURE__*/_jsx(SearchContainer, {
        children: /*#__PURE__*/_jsx(Search, {
          onSearch: handleSearch
        })
      }), /*#__PURE__*/_jsx(TenantList, {
        open: isSidebarOpen,
        mobile: isMobile,
        tablet: isTablet,
        children: filteredLinks.map(link => {
          // Determine the href value based on the presence of 'to' or 'href'
          const linkHref = link.to || link.href;

          // Ensure that either 'to' or 'href' is provided
          if (!linkHref) {
            console.error(`Navigation link "${link.label}" is missing 'to' or 'href'`);
            return null; // Skip rendering this link
          }
          return /*#__PURE__*/_jsxs(StyledOption, {
            onClick: () => handleLinkClick(link),
            active: link === activeLink,
            href: linkHref,
            children: [/*#__PURE__*/_jsxs(LabelContainer, {
              children: [link.icon, /*#__PURE__*/_jsx(TenantLabel, {
                mobile: isMobile,
                children: link.label
              })]
            }), link === activeLink && (_Check || (_Check = /*#__PURE__*/_jsx(Check, {
              size: "md"
            })))]
          }, typeof link.label === 'string' ? link.label : `element-${links.indexOf(link)}`);
        })
      }), showFooter && /*#__PURE__*/_jsx(TenantFooter, {
        mobile: isMobile,
        tablet: isTablet,
        children: /*#__PURE__*/_jsxs(Button, {
          variant: "ghost",
          fullWidth: true,
          onClick: () => {
            handleClose();
            if (addTenant) {
              addTenant();
            }
          },
          children: [_CirclePlus || (_CirclePlus = /*#__PURE__*/_jsx(CirclePlus, {})), "\xA0\xA0Add Cloud ID"]
        })
      })]
    })
  });
}
export default TenantSwitcher;